// Exports
export default {
	"fullLoadingSkeleton": "fullLoadingSkeleton_lcZp1",
	"oneColLayout": "oneColLayout_3GHmC"
};
